import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const OnlineMarketplaceDevelopmentInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Online Marketplace Development in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Your Marketplace Hub</Subheading>}
        heading={
          <Heading>
            Online <span tw="text-primary-500">Marketplace Development</span> in
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we excel in online marketplace development in
            **Dubai**, creating robust, scalable platforms that connect buyers
            and sellers seamlessly. Build your multi-vendor empire with our
            expert solutions.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1607082349566-187342175e2f?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1612469293568-38a5cdbdb5cc?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Create Your Marketplace"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Advanced Marketplace Solutions in Dubai"
        description="We build platforms that empower multi-vendor success."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Multi-Vendor Support",
            description: "Seamless management for multiple sellers.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Scalable Architecture",
            description: "Grow your marketplace without limits.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Custom Features",
            description: "Tailored tools for vendors and buyers.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Transactions",
            description: "Safe payments for all users.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-Friendly Design",
            description: "Optimized for shopping on any device.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Dubai’s top marketplace developers.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Marketplace Development Process"
        description={
          <Description>
            We craft your online marketplace with precision:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Define your marketplace vision and scope.</li>
              <li>Design: Create an intuitive, vendor-friendly interface.</li>
              <li>Development: Build robust multi-vendor functionality.</li>
              <li>Integration: Add payment, shipping, and analytics tools.</li>
              <li>Testing: Ensure performance and security for all users.</li>
              <li>Launch: Deploy a thriving marketplace platform.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1516321497487-e288fb19713f?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1526406915894-7bcd65f60845?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1609921141835-710b7fa6e438?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Marketplace Success in Dubai"
        description="Our platforms drive growth and engagement."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Vendor Growth",
            description: "Onboarded 200+ vendors in 6 months.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Rapid Launch",
            description: "Marketplace live in under 3 weeks.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "User Satisfaction",
            description: "95% positive feedback from users.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Connect Buyers & Sellers?</Subheading>}
        heading="Online Marketplace Development in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for online marketplace development in
            Dubai. Build a powerful, scalable platform for your multi-vendor
            business—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1552581234-26160f608093?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1532363814356-df99100ae399?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1475873326779-3eae1a9c0d13?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
